import { U2000InputTagEnum, type U2000InputTagType } from '../components/formControls/input/U2000InputTag';

/** Filtre alpha (lettres et espaces). */
export function u2000InputTagFilterAlpha(val: string): string {
  return val.replace(/[^a-zA-Z ]/g, '');
}

/** Filtre alphanum (lettres, chiffres, tiret, espace). */
export function u2000InputTagFilterAlphanum(val: string): string {
  return val.replace(/[^a-zA-Z0-9- ]/g, '');
}

/** Filtre numérique. */
export function u2000InputTagFilterNumeric(val: string): string {
  return val.replace(/[^0-9]/g, '');
}

/** Filtre date (chiffres et séparateurs courants). */
export function u2000InputTagFilterDate(val: string): string {
  return val.replace(/[^0-9/-]/g, '');
}

/** Résout la fonction de filtre selon le type U2000InputTag (défaut alphanum). */
export function resolveU2000InputTagFilter(type?: U2000InputTagType): (val: string) => string {
  switch (type) {
    case U2000InputTagEnum.ALPHA:
      return u2000InputTagFilterAlpha;
    case U2000InputTagEnum.NUMERIC:
      return u2000InputTagFilterNumeric;
    case U2000InputTagEnum.DATE:
      return u2000InputTagFilterDate;
    case U2000InputTagEnum.ALPHANUM:
    default:
      return u2000InputTagFilterAlphanum;
  }
}
